// made to match the options for a Vuetify v-data-table
export interface DataTableOptions {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
    groupBy: string[];
    groupDesc: boolean[];
    multiSort: boolean;
    mustSort: boolean;
}

export class PagingParameter {
    constructor(options: DataTableOptions, afterDate?: string | null, beforeDate?: string | null) {
        this.sortBy = options.sortBy && options.sortBy.length > 0 ? options.sortBy[0] : null;
        this.sortDesc = options.sortDesc && options.sortDesc.length > 0 ? options.sortDesc[0] : null;
        this.limit = options.itemsPerPage ?? null;
        this.offset = options.itemsPerPage && options.page ? options.itemsPerPage * (options.page - 1) : null;
        this.afterDate = afterDate ? afterDate : null;
        this.beforeDate = beforeDate ? beforeDate : null;
    }

    // We have to leave room for the possibility of undefined values from DataTableOptions
    // That's why all of these options can be null
    limit: number | null = 0;
    offset: number | null = 0;
    sortBy: string | null = null;
    sortDesc: boolean | null = null;
    afterDate: string | null = null;
    beforeDate: string | null = null;
}
